import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Loader2, AlertTriangle, ArrowLeft } from "lucide-react";
import BrandHeader from "@/components/BrandHeader";
import PixPanel from "@/components/PixPanel";
import Footer from "@/components/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

export default function PayPage() {
  const { txId } = useParams();
  const [payment, setPayment] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/payments/${txId}`);
        if (cancelled) return;
        // /api/payments/{id} returns the stored doc; map to PixPanel shape
        setPayment({
          transaction_id: data.id || txId,
          mistic_transaction_id: data.mistic_transaction_id,
          amount: data.amount,
          qr_code_base64: data.qr_code_base64,
          copy_paste: data.copy_paste,
          status: data.status,
          created_at: data.created_at,
          expires_at: data.expires_at,
        });
      } catch (e) {
        if (!cancelled) setError(e?.response?.data?.detail || "Pagamento não encontrado");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [txId]);

  return (
    <div className="app-shell">
      <main className="flex-1 w-full pt-10 sm:pt-14 pb-10">
        <div className="container-narrow">
          <BrandHeader />
          {loading && (
            <div className="neon-card rounded-[28px] p-10 flex flex-col items-center gap-3 text-[var(--muted)]" data-testid="pay-loading">
              <Loader2 className="w-7 h-7 spin text-[var(--neon)]" />
              <span className="mono uppercase tracking-[0.2em] text-xs">carregando pagamento...</span>
            </div>
          )}
          {!loading && error && (
            <div className="neon-card rounded-[28px] p-10 text-center" data-testid="pay-error">
              <AlertTriangle className="w-10 h-10 text-[#ff5577] mx-auto mb-3" />
              <h2 className="text-xl font-semibold mb-1">Pagamento não encontrado</h2>
              <p className="text-sm text-[var(--muted)] mb-5">
                Este link de cobrança expirou ou é inválido.
              </p>
              <Link
                to="/"
                className="neon-ghost-btn inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs mono uppercase tracking-[0.18em]"
                data-testid="pay-error-home-link"
              >
                <ArrowLeft className="w-3.5 h-3.5" /> voltar ao início
              </Link>
            </div>
          )}
          {!loading && !error && payment && (
            <PixPanel
              payment={payment}
              onReset={() => (window.location.href = "/")}
              hideBack
            />
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
